import { FC, useState } from "react";

import DeleteProviderBaseURLModal from "@/components/DeleteProviderBaseURLModal";
import ProviderBaseURLModal from "@/components/ProviderBaseURLModal";
import { useUser } from "@/context/user-context";
import { Button } from "@/components/ui/button";
import { TrashIcon } from "@heroicons/react/outline";
import { SettingsTable } from "@/components/SettingsTable";
import { ProviderBaseURL } from "@/types/provider-base-urls";

const ProviderBaseURLs: FC = () => {
  const [isDeleteProviderBaseURLModalOpen, setDeleteProviderBaseURLModalOpen] =
    useState<boolean>(false);
  const [isProviderBaseURLModalOpen, setProviderBaseURLModalOpen] =
    useState<boolean>(false);
  const [selectedProviderBaseURLId, setSelectedProviderBaseURLId] = useState<
    number | null
  >(null);

  const userContext = useUser();
  const providerBaseURLs = userContext.providerBaseURLs;

  const handleCreate = () => {
    setProviderBaseURLModalOpen(true);
  };

  const handleDelete = (id: number) => {
    setDeleteProviderBaseURLModalOpen(true);
    setSelectedProviderBaseURLId(id);
  };

  const columns = [
    {
      header: "Name",
      content: (item: ProviderBaseURL) => item.name,
    },
    {
      header: "URL",
      content: (item: ProviderBaseURL) => item.url,
    },
    {
      header: "Provider",
      content: (item: ProviderBaseURL) => item.provider,
    },
    {
      header: "API Key",
      content: () => "********",
    },
  ];

  const actions = [
    {
      label: "Delete",
      icon: <TrashIcon className="h-4 w-auto" aria-hidden="true" />,
      onClick: (item: ProviderBaseURL) => handleDelete(item.id),
      className: "text-red-500 hover:!bg-red-50 hover:!text-red-600",
    },
  ];

  return (
    <>
      <SettingsTable<ProviderBaseURL>
        data={providerBaseURLs}
        columns={columns}
        actions={actions}
        isLoading={false}
        keyExtractor={(item) => item.id}
        emptyStateMessage="No provider base URLs found."
      />
      <div className="mt-4 inline-flex items-center">
        <Button onClick={handleCreate}>Create new</Button>
      </div>
      {isDeleteProviderBaseURLModalOpen && selectedProviderBaseURLId && (
        <DeleteProviderBaseURLModal
          open={isDeleteProviderBaseURLModalOpen}
          providerBaseURLId={selectedProviderBaseURLId}
          setOpen={setDeleteProviderBaseURLModalOpen}
        />
      )}
      {isProviderBaseURLModalOpen && (
        <ProviderBaseURLModal setOpen={setProviderBaseURLModalOpen} />
      )}
    </>
  );
};

export default ProviderBaseURLs;
